import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import React, {useContext, useState, useEffect} from 'react';
import config from "common/configs/config";
import { LOGIN_USER_RETRAIT, LOGOUT_USER_RETRAIT, SOCIAL_LOGIN_RETRAIT } from "./actionTypes";
import { apiErrorRetrait, loginSuccessRetrait, logoutUserSuccessRetrait, socialLoginRetrait } from "./actions";
import axios from "axios";
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import { postJwtLogin} from "../../../helpers/fakebackend_helper";
const fireBaseBackend = getFirebaseBackend();

function* loginUserRetrait({ payload: { user, history } }) {
  try {
      const response = yield call(postJwtLogin, { login: user.email, password: user.password });
      localStorage.setItem("tokenRetrait", response.data);
      localStorage.setItem("refreshTokenRetrait", response.data.refreshToken);
      localStorage.setItem("userRetrait", JSON.stringify(response.data.user));
      yield put(loginSuccessRetrait(response));
      history('/retrait'); 
  } catch (error) {
    yield put(apiErrorRetrait(error));
  }
}

function* logoutUserRetrait({ payload: { history } }) {
  try {
    localStorage.clear();
    history('/login-retrait');
  } catch (error) {
    yield put(apiErrorRetrait(error));
  }
}

// function* socialLoginRetrait({ payload: { type, history } }) {
  // try {
  //   if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
  //     const fireBaseBackend = getFirebaseBackend();
  //     const response = yield call(fireBaseBackend.socialLoginUser, type);
  //     if (response) {
  //       history("/dashboard");
  //     } else {
  //       history("/login");
  //     }
  //     localStorage.setItem("authUser", JSON.stringify(response));
  //     yield put(loginSuccess(response));
  //   }
  //   const response = yield call(fireBaseBackend.socialLoginUser, type);
  //   if(response)
  //   history("/dashboard");
  // } catch (error) {
  //   yield put(apiError(error));
  // }
// }

function* authSagaRetrait() {
  yield takeEvery(LOGIN_USER_RETRAIT, loginUserRetrait);
  yield takeLatest(SOCIAL_LOGIN_RETRAIT, socialLoginRetrait);
  yield takeEvery(LOGOUT_USER_RETRAIT, logoutUserRetrait);
}

export default authSagaRetrait;
